import { useEffect, useState } from "react";
import "./StickyMobileCta.css";

function StickyMobileCta() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > window.innerHeight * 0.6);
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className={`landing-sticky-cta${visible ? " visible" : ""}`}>
      <a href="https://app.tablify.hu/register" className="landing-btn-primary">
        Ingyenes Kipróbálás
      </a>
    </div>
  );
}

export default StickyMobileCta;
